export default "__VITE_ASSET__DTqNGBHT__"